import axios from "axios";
import routes from "../app/routes";

const prepareFormDataForSend = (values) => {
  let formData = {
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    password: values.password,
  };
  return formData;
};

export const adminActions = {
  loadAdmins: (dispatch) => {
    axios.get(routes.api.admins.index).then((resp) => {
      dispatch({ type: "loadAdmins", admins: resp.data.data });
    });
  },
  saveAdmin: (dispatch, adminId, values, successCallback, errorCallback) => {
    if (adminId == 0) {
      axios
        .post(routes.api.admins.create, {
          ...prepareFormDataForSend(values),
        })
        .then((resp) => {
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    } else {
      axios
        .put(routes.api.admins.update(adminId), {
          ...prepareFormDataForSend(values),
        })
        .then((resp) => {
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },
  deleteAdmin: (dispatch, adminId) => {
    axios.delete(routes.api.admins.destroy(adminId)).then((resp) => {
      dispatch({
        type: "deleteAdmin",
        adminId: adminId,
      });
    });
  },
  showCreateForm: (dispatch) => {
    dispatch({ type: "showModal", currentUser: null });
  },
  showEditForm: (dispatch, row) => {
    dispatch({ type: "showModal", currentUser: row });
  },
  hideModal: (dispatch) => {
    dispatch({ type: "hideModal" });
  },
};
